import { useState } from "react";
import TableFull from "./table-full";
import TableSummarized from "./table-summarized";
import DialogExport from "./dialog-export";

export const LONGTERM_STATUS = new Map([
  ["AB", "Aberto"],
  ["CA", "Cancelado"],
  ["LQ", "Liquidado"],
  ["LS", "Liquidado Substituído"],
]);

export default function TableView({
  data,
  totalRegistros,
  page,
  sizePerPage,
  onTableChange,
  viewType,
}) {
  const [openExportBoletos, setOpenExportBoletos] = useState(false);
  const [selectedTitles, setSelectedTitles] = useState([]);

  const downloadBoleto = (url) => {
    console.log(url);
    if (url) {
      window.open(url, "_blank");
    }
  };

  const handleExportBoletos = (selectedRows) => {
    setOpenExportBoletos(true);
    setSelectedTitles(selectedRows);
  };

  if (viewType === "full") {
    return (
      <TableFull
        data={data}
        onExportBoletos={handleExportBoletos}
        totalRegistros={totalRegistros}
        page={page}
        sizePerPage={sizePerPage}
        onTableChange={onTableChange}
      />
    );
  }
  return (
    <>
      {viewType === "full" ? (
        <TableFull
          data={data}
          onExportBoletos={handleExportBoletos}
          downloadBoleto={downloadBoleto}
          totalRegistros={totalRegistros}
          page={page}
          sizePerPage={sizePerPage}
          onTableChange={onTableChange}
        />
      ) : (
        <TableSummarized
          data={data}
          downloadBoleto={downloadBoleto}
          onExportBoletos={handleExportBoletos}
          totalRegistros={totalRegistros}
          page={page}
          sizePerPage={sizePerPage}
          onTableChange={onTableChange}
        />
      )}
      {openExportBoletos && (
        <DialogExport
          onClose={() => setOpenExportBoletos(false)}
          titles={selectedTitles}
        />
      )}
    </>
  );
}
